import React from 'react';
import classNames from 'classnames';

import css from './IconClock.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconClock = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6663 6.99992C13.6663 10.6818 10.6816 13.6666 6.99967 13.6666C3.31778 13.6666 0.333008 10.6818 0.333008 6.99992C0.333008 3.31802 3.31778 0.333252 6.99967 0.333252C10.6816 0.333252 13.6663 3.31802 13.6663 6.99992Z"
        fill="#BEDC61"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.99967 3.83325C7.27582 3.83325 7.49967 4.05711 7.49967 4.33325V6.79281L9.0199 8.31303C9.21516 8.50829 9.21516 8.82488 9.0199 9.02014C8.82463 9.2154 8.50805 9.2154 8.31279 9.02014L6.64612 7.35347C6.55235 7.2597 6.49967 7.13253 6.49967 6.99992V4.33325C6.49967 4.05711 6.72353 3.83325 6.99967 3.83325Z"
        fill="#F6FCD6"
      />
    </svg>
  );
};

export default IconClock;
